import React, { forwardRef } from 'react'
import { useHistory } from 'react-router-dom'

import { useAuth, useBasket, useToastify } from '../../providers'

import { Button } from '../button'
import { Column } from '../column'
import { Content } from '../content'
import { Row } from '../row'
import { Text } from '../text'
import { HeaderBottomBar } from '../header-bottom-bar'

import { useStyle } from './header.styles'

export const Header = forwardRef<HTMLDivElement>((_, ref) => {
  const history = useHistory()
  const classes = useStyle()

  const { isLoggedIn, onLogout } = useAuth()
  const { onClearBasket } = useBasket()
  const { open } = useToastify()

  const handleOnClick = (state: boolean) => () => {
    if (state) {
      open({
        text: 'You are now logged out',
        tx: 'header.logout.plate'
      })
    }
  }

  const handleOnLogout = () => {
    const openToastify = handleOnClick(true)
    if (onLogout && onClearBasket) {
      onClearBasket()
      onLogout()
      openToastify()
    }
  }

  const handleOnNavigate = (path: string) => () => {
    history.push(path)
  }

  return (
    <Column fullWidth ref={ref}>
      <Row className={classes.container}>
        <Content>
          <Row fullWidth justifyContent="flex-end">
            <Row
              className={classes.rightContainer}
              justifyContent="space-between"
            >
              <Row className={classes.button}>
                <Text color="white" preset="secondTitle" text="USD" />
              </Row>
              <Row>
                {isLoggedIn ? (
                  <Button
                    className={classes.button}
                    color="yellow"
                    preset="borderButton"
                    text="LOGOUT"
                    textColor="yellow"
                    textPreset="secondTitle"
                    tx="header.logout"
                    onClick={handleOnLogout}
                  />
                ) : (
                  <Row>
                    <Button
                      className={classes.button}
                      color="yellow"
                      preset="borderButton"
                      text="LOGIN"
                      textColor="yellow"
                      textPreset="secondTitle"
                      tx="header.login"
                      onClick={handleOnNavigate('/sign-in')}
                    />
                    <Text
                      className={classes.auth}
                      color="white"
                      preset="secondTitle"
                      text="Sign Up"
                      tx="header.signUp"
                      onClick={handleOnNavigate('/sign-up')}
                    />
                  </Row>
                )}
              </Row>
            </Row>
          </Row>
        </Content>
      </Row>
      <HeaderBottomBar />
      <Column fullWidth id="submenu-header" />
    </Column>
  )
})
